<template>
  <div class="actionLog">
    <div class="section">
      <div class="search">
        <div class="search-title" style="border-left: 1px solid #738089;">
          <span>{{ $t('rawData.pn') }}：</span>
          <el-input v-model="search.pn" clearable></el-input>
        </div>
        <div class="search-title">
          <span>{{ $t('rawData.Equipment_number') }}：</span>
          <el-input v-model="search.sn" clearable></el-input>
        </div>
        <div class="search-title">
          <span>{{ $t('rawData.Equipment_coding') }}：</span>
          <el-input v-model="search.devcode" clearable></el-input>
        </div>
        <div class="search-title">
          <span>{{ $t('rawData.Device_address') }}：</span>
          <el-input v-model="search.devaddr" clearable></el-input>
        </div>
        <div class="search-title">
          <span>{{ $t('rawData.date') }}：</span>
          <el-date-picker :editable="false" clearable type="date" v-model="search.date"
            :picker-options="pickerrangeOptions" :placeholder="$t('rawData.Please_date')" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd" ref="dateDay" popper-class="select-date1"></el-date-picker>
        </div>
        <el-button class="button button-solid" @click.stop="getData">
          <i class="el-icon-search"></i>
        </el-button>
      </div>
      <div class="search-title" style="height: 42%;overflow: auto;overflow-wrap: break-word;color: #fff;">
        <div v-for="(item, index) in analysisData" :key="index" style="margin: 10px 0;">
          <span>devcode：{{ item.devcode }}</span>
          <span>gts：{{ item.gts }}</span>
          <div>dat：{{ item.dat }}</div>
        </div>
      </div>
      <div class="tablebottom">
        <div class="search">
          <div class="search-title">
            <span>{{ $t('rawData.encrypted') }}</span>
            <el-select v-model="search.encryption" :placeholder="$t('rawData.Please_type')">
              <el-option :label="$t('rawData.yes')" value="0"></el-option>
              <el-option :label="$t('rawData.no')" value="1"></el-option>
            </el-select>
          </div>
          <div class="search-title">
            <span>{{ $t('rawData.raw_data') }}：</span>
            <el-input v-model="search.repdat"></el-input>
          </div>
          <el-button class="button button-solid" @click.stop="analysisClick">{{ $t('rawData.analysis') }}</el-button>
        </div>
      </div>
      <!-- <div
        class="search-title"
        style="height: 45%;overflow: auto;overflow-wrap: break-word;color: #fff;"
      >{{ textarea }}</div>-->
      <div style="height: 45%;overflow: auto;">
        <el-input type="textarea" :rows="17" v-model="textarea"></el-input>
      </div>
    </div>
  </div>
</template>
<script>
// import accountDialog from "@/components/dialognew";
import { mapState } from 'vuex';
export default {
  components: {
    // accountDialog
  },
    computed: {
            ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  data() {
    return {
      emptyText: false,
      paginationControl: false,
      isLoading: false,
      analysisData: [],
      textarea: "",
      search: {
        pn: "",
        devaddr: "1",
        devcode: "",
        date: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + (new Date().getDate()),
        sn: "",
        encryption: "0",
        repdat: ""
      },
      pickerrangeOptions: {
        disabledDate: time => {
          return (
            time.getTime() >
            new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1
            )
          );
        }
      }
    };
  },
  filters: {
    replacePlusWithSpace(str) {
      return str.replace(/\+/g, ' ').replace(/=/g, ' ');
    }
  },
  mounted() { },
  methods: {
    // 列表数据
    getData(reset) {
      this.paginationControl = false;
      this.isLoading = true;
      this.analysisData = [];
      let params = {
        pn: this.search.pn,
        sn: this.search.sn,
        devcode: this.search.devcode,
        devaddr: this.search.devaddr,
        date: this.search.date,
        i18n: this.$lang.currentLang
      };
      let url = this.isMicroService ? "/drt/api/auth/web/deviceRawDat" : "adminQueryDeviceDat";
        // info.Loading = true;
        this.$request[this.method](url, params).then(res => {
        if (res[this.code] == 0) {
          if (res[this.resData]) {
            this.analysisData = res[this.resData].row;
          }
        } else {
         this.isMicroService ? this.$message.error(res.errorMessage): this.$message.error(this.$t(`errCode.${res.err}`));
        }
        this.isLoading = false;
      });
    },
    // ===== 【微服务版本】base64ToHex（解析接口专用）start（未上线暂注释；上线后请取消注释） =====
    // // base64转hex（微服务解析接口需要hex格式）
    // base64ToHex(base64) {
    //   const binary = atob(base64.replace(/\s/g, ""));
    //   let hex = "";
    //   for (let i = 0; i < binary.length; i++) {
    //     hex += binary.charCodeAt(i).toString(16).padStart(2, "0");
    //   }
    //   return hex;
    // },
    // ===== 【微服务版本】base64ToHex end =====
    // 解析
    analysisClick() {
      let repdat = this.$options.filters["replacePlusWithSpace"](
        this.search.repdat
      );
      let params = {
        encryption: this.search.encryption,
        devcode: this.search.devcode,
        i18n: this.$lang.currentLang
      };
      // ===== 【微服务版本】adminDeviceDatParse start（微服务接口未上线，暂注释；上线后：取消注释本段，并注释掉下方【原dis版本】） =====
      // if (this.isMicroService) {
      //   // 微服务接口需要hex格式，将base64转码
      //   let hexStr;
      //   try {
      //     hexStr = this.base64ToHex(this.search.repdat);
      //   } catch (e) {
      //     this.$message.error("base64格式错误");
      //     return;
      //   }
      //   params.hex = [hexStr];
      // } else {
      //   params.repdat = repdat;
      // }
      // let url = this.isMicroService ? "/drt/api/auth/web/deviceDat/deviceDataHex/xml/analysis" : "adminDeviceDatParse";
      // this.$request[this.isMicroService ? "postDEVMicroservices" : "get"](url, params).then(res => {
      //   if (res[this.code] == 0) {
      //     this.textarea = res[this.resData];
      //   } else {
      //     this.isMicroService ? this.$message.error(res.errorMessage): this.$message.error(this.$t(`errCode.${res[this.code]}`));
      //   }
      // });
      // ===== 【微服务版本】adminDeviceDatParse end =====
      // ===== 【原dis版本】adminDeviceDatParse start（当前启用；微服务上线后请注释掉本段） =====
      params.repdat = repdat;
      this.$request.get("adminDeviceDatParse", params).then(res => {
        if (res.err == 0) {
          this.textarea = res.dat;
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
      // ===== 【原dis版本】adminDeviceDatParse end =====
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.actionLog {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;

  .button {
    height: 48px;
    line-height: 48px;
    padding: 0 25px;
    margin-top: 0px;
    color: @primaryTextColor;
    background: transparent;
    border: none;
  }

  // margin: 24px 24px 50px 24px;
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .search {
    margin: 0px;
    align-self: flex-end;
    padding: 0px 0px 0 10px;
  }

  .section {
    // padding-bottom: 10px;
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: hidden;

    // .list-header {
    //   .title {
    //    font-size:16px;
    //    font-weight: bold;
    //    color: #333;
    //    letter-spacing: 1.5px;
    //     // .sc(24px, #333);
    //   }
    // }
    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation {
        // color: @primaryTextColor;
        color: #fff;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);
      border-bottom: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 6px;
    right: 140px;
    height: 24px;
    width: 24px;
    // background: url(../../../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  /deep/.el-date-editor .el-range-input {
    color: #fff;
    background-color: #222d35;
    width: 160px;
    line-height: 36px !important;
    height: 36px !important;
  }
}
</style>
<style lang="less">
/deep/.el-range__icon {
  margin-left: 25px;
}

/deep/.el-date-editor--daterange {
  color: #fff;
  background-color: #2b3842;
}

.el-date-editor .el-range-separator {
  color: #fff !important;
  width: 18%;
  line-height: 36px;
}

.select-date1.el-picker-panel {
  background-color: #222d35;
  border: none;
  padding-top: 10px;

  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222d35;
    }

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }

  .el-date-range-picker__header {
    color: #fff;
  }

  .in-range {
    background-color: #222d35;
  }

  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: @primaryTextColor;
    text-align: center;
  }

  .el-date-table td.today span {
    color: @primaryTextColor;
    font-weight: 700;
  }

  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }

  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background-color: @primaryTextColor;
    border: @primaryTextColor;
  }

  .el-date-table td.in-range {
    background-color: #222d35;
  }

  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }

  .el-date-table td {
    color: #fff;
  }

  .el-date-table td.disabled div {
    background-color: #222d35 !important;
    color: #606266 !important;
  }
}

.actionLog {
  .search {
    display: flex;

    // #下拉选框#
    .select-search-recharge {
      background-color: rgb(34, 45, 53);
      box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
      border-radius: 4px;
      border: none;
      padding: 8px 0px;

      .el-select-dropdown__list {
        padding: 0px;
      }

      .el-select-dropdown__item {
        padding: 0px 16px;
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item.hover {
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
      }

      .el-select-dropdown__item.selected {
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item:hover {
        padding: 0px 16px;
        background: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item.selected .select-label {
        padding: 0px;
      }

      // 对号
      .el-select-dropdown__item.selected:before,
      .el-select-dropdown__item.selected .select-label:before,
      .el-select-dropdown__item.selected.choose-num:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../../assets/img/general/Icon_Duihao.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        position: absolute;
        top: 8px;
        right: 16px;
      }
    }

    .select-search-project {
      .el-select-dropdown__list {
        padding: 0 16px;
      }

      .el-select-dropdown__item {
        height: 40px;
        line-height: 40px;
        box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
      }
    }

    .selectClearNew {

      // 下拉选中清除按钮
      .el-icon-circle-close:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../../assets/img/general/Icon_SelectClear.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        // position: absolute;
        // top: 8px;
        // right: 16px;
      }
    }

    .search-title {
      color: #fff;
      padding: 5px;
    }

    .el-select,
    .el-input {
      width: 165px;
      border-right: 1px solid #738089;
    }

    .el-input__inner {
      background: transparent;
      border: none;
      height: 36px;
      line-height: 36px;
      color: #ffffff;
      padding: 0 16px;
    }
  }

  .upload-button {
    width: 100%;
  }
}
</style>
<style lang="less" scoped>
/deep/.el-textarea__inner {
  background-color: #222d35;
  color: #fff;
}
</style>